// Localizations will go in separate database table

import { ArticleAppendixVersion, ArticleChangeImportance, ArticleNote, ArticleSubscriber, ArticleType, ReleaseRecord } from ".";

export type ArticleReleaseDetails = {
    releasedDate: Date,
    releasedBy: {
        userId: string,
        email: string,
    };
};

export type BaseArticleContent =
    {
        articleId: string,
        articleVersionId: string,
        version: number,
        release:ArticleReleaseDetails | null,

        type: ArticleType,

        list: {
            id: string,
            name: string,
        };
        topic: {
            id: string,
            name: string;
        },

        title: string,
        description: string,
        reference: string,
        date: Date | null,
        url: string,

        requirements: string;

        importance: ArticleChangeImportance,
        changeDescription: string,
        assessment: string,
    };









export type Article =
    BaseArticleContent &
    {

        notes: ArticleNote[],

        appendices: ArticleAppendixVersion[],

        releaseRecords: ReleaseRecord[];

        // If need be, changes can be assembled from events
    };

export type ArticleVersionList =
    {
        versions: Article[],
        subscribers: ArticleSubscriber[];
    };

export type ArticleListing =
    BaseArticleContent &
    {
        subscriberCount: number,
        subscribed: boolean,
        lastNote: {
            date: Date,
            user: { userId: string, email: string; };
        } | null,
        missingRequirements: boolean
    };

export const ArticleSorts = ['list', 'topic', 'type', 'date', 'title', 'releaseDate', 'lastNote', 'missingRequirements'] as const;
export type ArticleSort = typeof ArticleSorts[number];

export type ArticleParameters = {
    subscriberId?: string,
    sortBy?: ArticleSort,
    sortOrder?: 'asc' | 'desc',
    filter?: {
        typeId?: string,
        topicId?: string,
        listId?: string,
        searchTerm?: string,
        released?: boolean,
    };
};

export type ArticlePage = {
    page: number,
    totalItems: number,
    itemsPerPage: number,
    articles: ArticleListing[];
};

export const defaultArticlePublishedEmailTemplate = `
    <p>
        {contactperson.firstname}
    </p>
    <p>
        Lovkravet "<i>{article.title}</i>" i modulet "<i>{article.listname}</i>" er netop blevet opdateret og ligger klar til jer i lovservice portalen.
        <a href="{article.url}">Klik her for at se lovkravet</a>
    </p>
    <p>
        Hvis det er første gang du logger ind, skal du bruge navnet på din organisation ({company.siteId}) og den email adresse, som du modtager denne email på.
        Hvis din konto er oprettet af en kollaga, og du har glemt din adgangskode, kan du bruge "Glemt adgangskode" funktionen på login siden til at oprette en ny adgangskode.
    </p>
    <p>
        God fornøjelse med arbejdet.
    </p>
    <p>
        På vegne af LovService Teamet i CRECEA.
        Karen Klarskov Møller
    </p>
    <p>
        Du modtager denne email da du er oprettet som loveservice kontaktperson for {company.name}
        Hvis dette er en fejl, eller du ikke længere ønsker at modtage emails fra os, kan du ændre dine indstillinger i lovservice portalen.
        Alternativt kan du kontakte os på lovservice@crecea.dk  
    </p>
`;